export default __webpack_public_path__ + "static/media/hvac.647b973b.png";